import { defineMessages } from 'react-intl';

import * as dropdownOptions from './constants';

export const optionsMessages = defineMessages({
  [dropdownOptions.AWAITING_PAYMENT]: {
    defaultMessage: 'Awaiting Payment',
    id: '8ts2oj',
    description: 'Insights > Reports > Filters > Dropdown > option > Awaiting Payment',
  },
  [dropdownOptions.AWAITING_SHIPMENT]: {
    defaultMessage: 'Awaiting Shipment',
    id: 'n3M+2o',
    description: 'Insights > Reports > Filters > Dropdown > option > Awaiting Shipment',
  },
  [dropdownOptions.CANCELLED]: {
    defaultMessage: 'Cancelled',
    id: 'YrdNSV',
    description: 'Insights > Reports > Filters > Dropdown > option > Cancelled',
  },
  [dropdownOptions.ON_HOLD]: {
    defaultMessage: 'On Hold',
    id: 'Xj0ROg',
    description: 'Insights > Reports > Filters > Dropdown > option > On Hold',
  },
  [dropdownOptions.PENDING_FULFILLMENT]: {
    defaultMessage: 'Pending Fulfillment',
    id: 'NWPSE3',
    description: 'Insights > Reports > Filters > Dropdown > option > Pending Fulfillment',
  },
  [dropdownOptions.REJECTED_FULFILLMENT]: {
    defaultMessage: 'Rejected Fulfillment',
    id: 'QYzxMp',
    description: 'Insights > Reports > Filters > Dropdown > option > Rejected Fulfillment',
  },
  [dropdownOptions.SHIPPED]: {
    defaultMessage: 'Shipped',
    id: 'oEjJJo',
    description: 'Insights > Reports > Filters > Dropdown > option > Shipped',
  },
});
